/* eslint-disable no-console */
import convertKeys from 'utils/convert-keys'

export const requestHandler = async (url, method, body = null) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_CONSUMER_HOOKS_BASE_URL}${url}`, {
      method,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      ...(body && { body: JSON.stringify(convertKeys.toSnake(body)) }),
    })
    const resultJSON = await response.json()
    return convertKeys.toCamel(resultJSON)
  } catch (error) {
    console.error('error', error)
    return null
  }
}

export const getSubscriptionData = async (primaryEmail, isWeb = true) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CONSUMER_HOOKS_BASE_URL}/reklaim-protect-subscription-status`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ primaryEmail, isWeb }),
      },
    )
    const resultJSON = await response.json()
    return convertKeys.toCamel(resultJSON)
  } catch (error) {
    return null
  }
}

// Profile Info - User Profile
export const getUserProfile = async (userAlias) =>
  requestHandler(`/protect/profile-info/user-profile/${userAlias}`, 'GET')

export const setUserProfile = async (userAlias, data) =>
  requestHandler(`/protect/profile-info/user-profile/${userAlias}`, 'POST', data)

// Data Broker Removal Stats
export const getDataBrokerDeletionStats = async (userAlias) =>
  requestHandler(`/protect/data-broker-deletion/${userAlias}`, 'GET')

// Data Breach Report
export const getBreachData = async (userAlias) =>
  requestHandler(`/reklaim-protect-breach-status`, 'POST', { userAlias })
